import React, { useEffect, useState } from 'react';
import LeaderBoardList from '../../../component/EliteGame/LeaderBoardList';
import { getAllLeaderBoard } from '../../../api/eliteGameApi';
import { useEliteGames } from '../../../context/EliteGamesContext';
const AllLeaderBoard = () => {
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const { setLoading } = useEliteGames();

  useEffect(() => {
    fetchData(page);
  }, [page, limit]);
  const handlePagination = (newPage) => {
    console.log('Page changed to:', newPage);
    setPage(newPage);
    // Implement pagination logic here if needed
  };
  const fetchData = async (pageNum) => {
    setLoading(true);
    const response = await getAllLeaderBoard({ page: pageNum, limit });
    setData(response);
    setLoading(false);
  };
  // You can fetch/filter all leaderboard data here
  return (
    <LeaderBoardList
      limit={limit}
      setLimit={setLimit}
      data={data}
      page={page}
      setPage={setPage}
      handlePagination={handlePagination}
    />
  );
};

export default AllLeaderBoard;
